import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { SiteRouterLink } from '../RouterLink';

const useStyles = makeStyles({name: "AppLogo"})(theme => ({
	logo: {
		marginRight: '2rem',
		display: 'inline-flex',
		textDecoration: 'none',
		color: '#d3302f',
		fontWeight: 500,
		fontSize: 28,
		alignItems: 'center',
		'& img': {
			display: 'block',
			height: '3rem',
		}
	}
}));

export const HaohanH1: React.FC<{lang: string}> = props => {
    const { lang } = props;
    const {classes} = useStyles();
    return (
        <>
            <SiteRouterLink className={classes.logo} to="/">
                <img
                    alt="Haohan logo"
                    width={60}
                    height={40}
                    src="/dist/img/logo.svg"
                />
                <Box
                    mt={1.5}
                    ml={-0.5}
                    display={{sm: 'none', md: 'inline-block'}}
                >
                    <Typography
                        variant="h1"
                        color="inherit"
                        fontSize='inherit'
                        fontWeight='inherit'
                    >
                        {lang === 'ru' ? 'Хаохань' : 'Haohan'}
                    </Typography>
                </Box>
            </SiteRouterLink>
        </>
    );
}
